import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/shared/Button/Button';
import { useAppDispatch, useAppSelector } from 'utils/hooks';

import activeEditor from 'domains/active_editor';
import products from 'domains/products';
import ui from 'domains/ui';

function findMobileNavigationElement() {
  // This is found in ChangeCatalogButton.tsx
  const mobileNavElem = document.querySelector(
    '.mobile-catalog-navigation'
  ) as HTMLDivElement | null;
  return !!mobileNavElem && !!mobileNavElem.offsetParent;
}

function MobileNavigation() {
  const dispatch = useAppDispatch();
  const activeProduct = useAppSelector(activeEditor.selectors.product);
  const showMobileSidebar = useAppSelector(ui.selectors.showMobileSidebar);
  const showSidebarProducts = useAppSelector(ui.selectors.showSidebarProducts);
  const showMobileUserPhotos = useAppSelector(ui.selectors.showMobileUserPhotos);
  const showEditorSidebar = useAppSelector(ui.selectors.showEditorSidebar);

  function handleWindowResizeForMobileNavigation() {
    dispatch(ui.actions.setHasMobileNavigation(findMobileNavigationElement()));
  }

  useEffect(() => {
    dispatch(ui.actions.setHasMobileNavigation(findMobileNavigationElement()));
    window.addEventListener('resize', handleWindowResizeForMobileNavigation);
  }, []);

  useEffect(() => {
    if (activeProduct && !products.utils.isCustomSizeProduct(activeProduct)) {
      dispatch(ui.actions.setShowMobileSidebar(false));
    }
  }, [activeProduct, dispatch]);

  return (
    <ul className="mobile-navigation-menu">
      <li>
        <Button
          type="bare"
          className={showMobileSidebar && showSidebarProducts ? 'active' : ''}
          onClick={() => {
            dispatch(ui.actions.mobileNavigationProducts());
          }}
        >
          <FontAwesomeIcon icon={['far', 'copy']} size="2x" />
          Sizes
        </Button>
      </li>
      <li>
        <Button
          type="bare"
          className={showMobileSidebar && !showSidebarProducts ? 'active' : ''}
          onClick={() => dispatch(ui.actions.mobileNavigationOptions())}
        >
          <FontAwesomeIcon icon="check-circle" size="2x" />
          Options
        </Button>
      </li>
      <li>
        <Button
          type="bare"
          className={showMobileUserPhotos ? 'active' : ''}
          onClick={() => dispatch(ui.actions.mobileNavigationPhotos())}
        >
          <FontAwesomeIcon icon="image" size="2x" />
          Photos
        </Button>
      </li>
      <li>
        <Button
          type="bare"
          className={!showMobileSidebar && !showMobileUserPhotos ? 'active' : ''}
          onClick={() => dispatch(ui.actions.mobileNavigationEdit())}
        >
          <FontAwesomeIcon icon="pencil-alt" size="2x" />
          Edit
        </Button>
      </li>
      <li className="editor-sidebar-trigger">
        <Button
          type="icon"
          icon={showEditorSidebar ? 'times' : 'ellipsis-vertical'}
          size="2x"
          onClick={() => dispatch(ui.actions.setShowEditorSidebar(!showEditorSidebar))}
        />
      </li>
    </ul>
  );
}

export default MobileNavigation;
